import { useState } from "react";
import { PaymentStep } from "../types/PaymentStep";

export const usePaymentNavigation = (currentPaymentPlanLine) => {
  const [step, setStep] = useState(PaymentStep.PAYMENT_PLAN_LINE);

  const allowedNavigation = allowedNavigationByStep(
    step,
    currentPaymentPlanLine
  );

  const paymentSteps = Object.keys(PaymentStep);

  const onNext = () => setStep(paymentSteps[paymentSteps.indexOf(step) + 1]);

  const onPrev = () => setStep(paymentSteps[paymentSteps.indexOf(step) - 1]);

  return {
    step,
    onPrev: allowedNavigation?.prev ? onPrev : undefined,
    onNext: allowedNavigation?.next ? onNext : undefined,
  };
};

const allowedNavigationByStep = (step, paymentPlanLine) => {
  if (!paymentPlanLine) return;
  switch (step) {
    case PaymentStep.PAYMENT_PLAN_LINE:
      return {
        prev: false,
        next: true,
      };
    case PaymentStep.PAYMENT_PLAN:
      return {
        prev: true,
        next: false, //paymentPlanLine.status === PaymentPlanLineStatus.PENDING,
      };
  }
};
